import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Crosshair, Thermometer, Orbit, Zap } from "lucide-react";
import { useLang } from "@/i18n";

const specIcons = [Crosshair, Zap, Orbit, Thermometer];

export default function Technology() {
  const ref = useRef(null);
  const { t } = useLang();
  const specs = t.tech.specs.map((s, i) => ({ ...s, icon: specIcons[i] }));
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const bgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} id="tecnologia" className="relative py-24 sm:py-32 border-b border-white/10 overflow-hidden" data-testid="technology-section">
      <motion.div style={{ y: bgY }} className="absolute inset-0 -z-10 opacity-[0.12]">
        <img src="/assets/parabola.webp" alt="" className="w-full h-[130%] object-cover grayscale" />
      </motion.div>

      <div className="max-w-7xl mx-auto px-6">
        <motion.p initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="overline-tag" data-testid="technology-overline">
          {t.tech.overline}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }}
          className="mt-4 font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl max-w-3xl"
        >
          <span className="text-volt">{t.tech.h2brand}</span> {t.tech.h2rest}
        </motion.h2>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {specs.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
              className="glass rounded-2xl p-7 group hover:border-volt/40 transition-colors duration-300" data-testid={`spec-card-${i}`}
            >
              <s.icon className="text-volt" size={26} strokeWidth={1.5} />
              <p className="mt-5 font-display font-bold text-3xl text-white drop-shadow-[0_0_12px_rgba(0,255,136,0.3)]">{s.value}</p>
              <p className="mt-1 text-sm font-semibold text-white/90">{s.label}</p>
              <p className="mt-3 text-xs text-steel leading-relaxed">{s.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
